module.exports = __webpack_public_path__ + "static/media/icon_125.afcdf958.svg";